module.exports = __webpack_public_path__ + "static/media/chat.75009b4f.png";